var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceExternalMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.2,31.7c0,1.8-1.5,2.9-1.5,2.9c-6.3,5.7-30.1,5.8-30.1,5.8s-1.8,0.1-2.3-1.7c-0.6-1.8-1.4-5.4-1.4-9 l-2.6-1.1c0,5.6,1.6,11.1,1.6,11.1c1.1,3.2,4.4,3,4.4,3s21.5,1,31.7-5.9c0,0,1.8-1.2,2.2-3.2c0.2-1.2,0.2-2.9,0.2-2.9L45.2,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.9,29.8v-2c0-3.6,0.8-7.2,1.4-9c0.6-1.8,2.3-1.7,2.3-1.7s23.8,0.1,30.1,5.8c0,0,1.5,1.2,1.5,2.9v5.8 l2.3-0.8v-3.4c0,0,0-2.2-0.2-3.3C46.8,22.2,45,21,45,21c-10.1-6.8-31.7-5.9-31.7-5.9s-3.4-0.2-4.4,3c0,0-1.6,5-1.6,10.6L9.9,29.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51,32.4c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2v-7.2c0-0.7,0.5-1.2,1.2-1.2s1.2,0.5,1.2,1.2V32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.1,32.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-6.5c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1V32.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M9.3,35.6h10.2v1.5c0,0.6,0.5,1.1,1.1,1.1h2.5c0.6,0,1.1-0.5,1.1-1.1v-1.8c0.8-0.4,1.4-1.2,1.4-2.2V33l0,0 l-0.3-3.7c0-1.1-0.4-2.1-1.1-3H25c0.2,0,0.4-0.2,0.4-0.5l0.2-1.3c0-0.3-0.2-0.5-0.5-0.5h-2.4L22,21.9c-0.4-1.2-1.5-2.5-3.5-2.5H8.6 l-0.1,1.8h10c1.4,0,1.7,1.3,1.7,1.3l1.2,3.5h-13v0.9h13.3c1.1,0.4,1.8,1.8,1.8,3l0.2,2.5l0.1,0.9c0,0.4-0.4,0.7-0.7,0.7H9.2 L9.3,35.6z M21.7,32c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.1-1-0.1c-1.9-0.1-1.9-0.8-1.9-1.6c0-0.9,0.2-1.7,3-1.7c1.3,0,1.2,0.8,1.2,1.7 C21.9,31.3,21.9,31.7,21.7,32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceExternalMirror);
export default __webpack_public_path__ + "static/media/device-external-mirror.3b61d0ffc0a2f5d0b80d63436055bc6c.svg";
export { ForwardRef as ReactComponent };